import React from 'react';
import {
  hasDismissedAlert,
  AlertRulesEngineOptions,
} from 'src/helpers/alerts/index.ts';
import { Rule } from 'src/helpers/rulesEngine';
import { Link } from 'src/components/Analytics';
import Alert from 'src/components/Alert/';
import { isActive } from 'src/helpers/page';

const AddressVerificationPending: Rule<JSX.Element, AlertRulesEngineOptions> = (
  state,
  options
) => {
  const { verificationStatus, status } = state.page;
  const alertKey = 'verify_address_pending';

  if (
    isActive({ status }) &&
    verificationStatus === 'AddressVerificationPending' &&
    !hasDismissedAlert(state.page.id, alertKey)
  ) {
    return {
      matched: true,
      result: (
        <Alert
          id={alertKey}
          type="amber"
          onClose={options!.onClose}
          page={state.page}
        >
          <p className="jg-space-mbn">
            Thanks. Weʼll send a letter to your home address to get you
            verified. Donʼt worry you can still receive donations in the
            meantime.{' '}
            <Link
              href="https://help.justgiving.com/hc/en-us/articles/202793181-When-will-I-receive-the-money-I-ve-raised-"
              rel="noreferrer noopener"
              target="_blank"
            >
              Learn more
            </Link>
          </p>
        </Alert>
      ),
    };
  }

  return { matched: false };
};

export default AddressVerificationPending;



// WEBPACK FOOTER //
// ./src/helpers/alerts/AddressVerificationPendingAlert.tsx